import React, { Component } from 'react';
import {
    toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn,
    MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge, MDBStepper, MDBStep
} from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';

class Challenges extends Component {
    constructor(props) {
        super(props);
        this.state = {
            challengeData: [],
            modal: false,
            modalPrizes: false,
            criteriaData: []
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.viewCriteriaAndPrizes = this.viewCriteriaAndPrizes.bind(this);
    }


    async componentWillMount() {

        this.props.loaderOn();
        let response = await this.dl.Get("/demonstrator/GetChallenges")
        let test = "";
        this.setState({
            challengeData: response.data
        })
        this.props.loaderOff();
        
    }

    viewCriteriaAndPrizes = (item) => {
        const { history } = this.props;
        history.push({
            pathname: '/salesforce/criteriaprizes',
            state: {
                criteriaData: item.criteriaList,
                subHeader: item.resultAreaDescription + " - " + item.resultSetDescription,
                resultAreaId: item.resultAreaId
            }
        })
    }

    
    render() {
        return (
            <div>
                <Header headerText="Challenges / Incentives"
                    hideSearch={true}
                />
                <MDBRow>
                    {
                        this.state.challengeData.map((item) => {
                            return (
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" >
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                                            <MDBIcon icon="medal" />&nbsp;{item.resultAreaDescription} - {item.resultSetDescription}

                                        </MDBCardTitle>
                                        <hr className="hr_grey" />
                                        <MDBCardText>
                                            <div>For Weeks:&nbsp;{item.startWeekId}&nbsp;-&nbsp;{item.endWeekId}</div>
                                        </MDBCardText>
                                        <div className="flex-row text-center" >
                                            <MDBBtn rounded color="purple" size="sm" onClick={() => this.viewCriteriaAndPrizes(item)}>View Criteria</MDBBtn>
                                            
                                            
                                        </div>


                                    </MDBCard>
                                </MDBCol>
                            )
                        })
                    }


                </MDBRow>
                
                
            </div>
        )
    }
}

export default Challenges;

